(function () {
    'use strict';
    var controllerId = 'cndRegister';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '_', cndRegister]);

    function cndRegister($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter, _) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');


        var vm = this;
        vm.title = 'Register';
        vm.view = 'detail';       //Mettendo 'detail' si elimina l'errore del $compile: ctreq
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "register"; //Utilizzato per pannello authorization		
        vm.authorization = {};
        vm.isVisibleLinkDomanda = false;
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.confirm = {};
        vm.maxStep = 1;
        vm.actualAdesione = 0;
        vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.PdfReady = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.myPristine = false;
        vm.isClickDay = false;
        vm.nrMesiTrc = 0;
        vm.errorAccess = '';
        vm.showToggle = false;
        vm.disableConfirm = false;


        //Pannelli dei dati (viewAccred)
        vm.showPanelAccred1 = true;
        vm.showPanelAccred2 = true;
        vm.setShowPanelAccred1 = setShowPanelAccred1;
        vm.setShowPanelAccred2 = setShowPanelAccred2;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.saving = false;

        vm.cndProgetto = {};
        vm.adesione = {};
        vm.urlRoot = datacontext.accreditamento_getURL();

        vm.testing = true;


        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Ragione Sociale', 'Codice Fiscale', 'Cod Ateco', 'Forma Giuridica'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };


        //Elenchi per filtri e finestra modale di Create

        vm.cmblist = {};
        vm.cmblist.l_nasc_paesi = [];
        vm.cmblist.l_nasc_province = [];
        vm.cmblist.l_nasc_comuni = [];

        vm.cmblist.l_res_paesi = [];
        vm.cmblist.l_res_province = [];
        vm.cmblist.l_res_comuni = [];
        vm.cmblist.l_res_tIndirizzi = [];

        vm.cmblist.l_dom_paesi = [];
        vm.cmblist.l_dom_province = [];
        vm.cmblist.l_dom_comuni = [];
        vm.cmblist.l_dom_tIndirizzi = [];

        vm.cmblist.sedeLeg_paesi = [];
        vm.cmblist.sedeLeg_province = [];
        vm.cmblist.sedeLeg_comuni = [];
        vm.cmblist.sedeLeg_tIndirizzi = [];

        vm.cmblist.sedeOp_paesi = [];
        vm.cmblist.sedeOp_province = [];
        vm.cmblist.sedeOp_comuni = [];
        vm.cmblist.sedeOp_tIndirizzi = [];

        vm.cmblist.tAssociazioni = [];
        vm.cmblist.tOrganismi = [];

        vm.cmblist.studioNot_province = [];
        vm.cmblist.studioNot_comuni = [];

        vm.cmblist.consReg_province = [];
        vm.cmblist.consReg_comuni = [];

        vm.cmblist.tAteco = [];

        vm.reset_L_PaeseNasc = reset_L_PaeseNasc;
        vm.reset_L_ComuneNasc = reset_L_ComuneNasc;

        vm.reset_L_PaeseRes = reset_L_PaeseRes;
        vm.reset_L_ComuneRes = reset_L_ComuneRes;
        vm.reset_L_DomUgualeRes = reset_L_DomUgualeRes;

        vm.reset_L_PaeseDom = reset_L_PaeseDom;
        vm.reset_L_ComuneDom = reset_L_ComuneDom;

        vm.reset_SedeLegale_Paese = reset_SedeLegale_Paese;
        vm.reset_SedeLegale_Comune = reset_SedeLegale_Comune;

        vm.reset_SedeOperativa_Paese = reset_SedeOperativa_Paese;
        vm.reset_SedeOperativa_Comune = reset_SedeOperativa_Comune;

        vm.reset_StudioNot_Comune = reset_StudioNot_Comune;

        vm.reset_ConsReg_Comune = reset_ConsReg_Comune;

        vm.reset_consorzio = reset_consorzio;

        vm.reset_L_PaeseNasc = reset_L_PaeseNasc;


        //Metodi su interfaccia
        vm.activated = false;

        //Gestione conferma input di tipo Email
        vm.save = save;

        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;

        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;
        vm.setStep = setStep;


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            vm.opened4 = false;
            vm.opened5 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
            else if (iOpened == 3) vm.opened3 = true;
            else if (iOpened == 4) vm.opened4 = true;
            else if (iOpened == 5) vm.opened5 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.L_DtNasc = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.L_Da = '';
                vm.changed = true;
            }
            else if (iOpened == 3) {
                vm.record.L_A = '';
                vm.changed = true;
            }
            else if (iOpened == 4) {
                vm.record.Associazione_Atto_Dt = '';
                vm.changed = true;
            }
            else if (iOpened == 5) {
                vm.record.Associazione_Reg_Dt = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        loadStepParams();
        activate();

        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {

                    vm.record.Id = 0;
                    vm.record.L_PaeseNascId = 0;
                    vm.record.L_Res_PaeseId = 0;
                    vm.record.L_Dom_PaeseId = 0;
                    vm.record.SedeLegale_PaeseId = 0;
                    vm.record.SedeOperativa_PaeseId = 0;
                    vm.confirm.SedeLegale_Email = '';
                    vm.confirm.SedeLegale_PEC = '';
                    vm.confirm.SedeOperativa_Email = '';
                    vm.confirm.SedeOperativa_PEC = '';

                    var isDebug = false;
                    if (isDebug) {
                        vm.record.L_Cognome = 'Rossi';
                        vm.record.L_Nome = 'Mario';
                        vm.record.L_CodiceFiscale = 'RSSMRA80A01I754N';
                        vm.record.L_Sesso = 'M';
                        vm.record.L_ProvNascId = 89;
                        getComuni_NascL(vm.record.L_ProvNascId);
                        vm.record.L_ComuneNascId = 6886;
                        vm.record.L_DtNasc = '01/01/1980';

                        vm.record.L_Res_ProvId = 89;
                        getComuni_ResL(vm.record.L_Res_ProvId);
                        vm.record.L_Res_ComuneId = 6886;
                        vm.record.L_Res_TIndirizzoId = 1;
                        vm.record.L_Res_Indirizzo = 'LIBERTA';
                        vm.record.L_Res_Civico = '1A';
                        vm.record.L_Res_Cap = '96010';
                        vm.record.L_DomUgualeRes = true;
                        vm.record.L_Ruolo = 'Amministratore';
                        vm.record.L_Da = '20/09/1999';
                        vm.record.L_A = '20/09/2015';

                        vm.record.SedeLegale_ProvId = 89;
                        getComuni_SedeLeg(vm.record.SedeLegale_ProvId);
                        vm.record.SedeLegale_ComuneId = 6886;
                        vm.record.SedeLegale_TIndirizzoId = 1;
                        vm.record.SedeLegale_Indirizzo = 'LIBERTA';
                        vm.record.SedeLegale_Civico = '1A';
                        vm.record.SedeLegale_Cap = '96010';
                        vm.record.SedeLegaleIsSedeOperativa = true;

                        vm.record.SedeLegale_Telefono = '09316565';
                        vm.record.SedeLegale_Cellulare = '3389895';
                        vm.record.SedeLegale_Email = 'm.rossi80@dominio.it';
                        vm.confirm.SedeLegale_Email = 'm.rossi80@dominio.it';
                        vm.record.SedeLegale_PEC = 'm.rossi80@dominio.it';
                        vm.confirm.SedeLegale_PEC = 'm.rossi80@dominio.it';                        

                        vm.record.RagioneSociale = 'LIBERTA';
                        vm.record.PIVA = '01234567897';
                        vm.record.CodiceFiscale = '01234567899';
                        vm.record.TAtecoId = 988;
                        vm.record.searchTextAteco = '[63] ATTIVIT� DEI SERVIZI D\'INFORMAZIONE E ALTRI SERVIZI INFORMATICI';
                        vm.record.TAssociazioneId = 2;
                    }

                    var promises = [
                        getPaesiNascL(),
                        getProvinceNascL(),

                        getPaesiResL(),
                        getProvinceResL(),
                        getTIndirizzi_ResL(),

                        getPaesiDomL(),
                        getProvinceDomL(),
                        getTIndirizzi_DomL(),

                        getPaesiSedeLeg(),
                        getProvinceSedeLeg(),
                        getTIndirizzi_SedeLeg(),

                        getPaesiSedeOp(),
                        getProvinceSedeOp(),
                        getTIndirizzi_SedeOp(),

                        getTAssociazione(),
                        getTOrganismo(),

                        getProvinceStudioNot(),

                        getProvinceConsReg(),

                        getTAteco()
                    ];
                    return common.activateController(promises, controllerId)
                        .then(function () {
                            return setStep(0);
                        });
                });
            }
        }


        //****************************************************
        // METODI GESTIONE VIEW
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function nextStep() {
            bDialog.confirmationDialog('Attenzione', 'Si sta passando alla Fase successiva, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    setStep(vm.actualStep + 1);
                },
                function () { //NO
                    //
                }
            );
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "F1";
            vm.titlesStep[0] = "1\u00BA Fase";
            vm.subtitlesStep[0] = "Registrazione";
            vm.descriptionsStep[0] = "Compilare il modulo e premere il pulsante 'Registra'.<br />Il <b>form di registrazione</b>, nel caso di Associazione Temporanea di Impresa/Scopo (ATI/ATS),<br />deve essere compilato dall'azienda capofila; nel caso di Consorzio, da una soltanto delle aziende facenti parte del consorzio.<br />Tale azienda ricever\xE0 le credenziali di accesso alla piattaforma (username e password).";

            //vm.labelsStep[1] = "B";
            //vm.titlesStep[1] = "Fase B";
            //vm.subtitlesStep[1] = "Dichiarazione tirocinante";
            //vm.descriptionsStep[1] = "In questa fase &egrave; richiesto l'inserimento dei dati necessari alla compilazione del 'Modulo di adesione del tirocinante' (Allegato B) e, se del caso, della 'Scheda del Progetto Formativo' (Allegato C).<br/>Per aggiungere l'eventuale secondo tirocinante utilizzare il pulsante 'Aggiungi Tirocinante'; per navigare tra i tirocinanti utilizzare il pulsante 'Scheda tirocinante'.";

            //vm.labelsStep[2] = "C";
            //vm.titlesStep[2] = "Fase C";
            //vm.subtitlesStep[2] = "Upload Documentale";
            //vm.descriptionsStep[2] = "In questa fase occore scaricare gli allegati A, B, C (nel caso ci sia) generati dal portale, firmarli (l'allegato A va firmato digitalmente) e ricaricarli unitamente all'altra documentazione richiesta, compilando integralmente l'elenco.";

            //vm.labelsStep[3] = "D";
            //vm.titlesStep[3] = "Fase D";
            //vm.subtitlesStep[3] = "Stampa ricevuta";
            //vm.descriptionsStep[3] = "In questa fase &egrave possibile stampare la 'Ricevuta di adesione' che contiene il numero di istanza da riportare nell'oggetto della PEC e da allegare nella stessa.";
        }

        function setStepDefault() {
            setStep(0);
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            vm.subStep = "";
            switch (vm.actualStep) {
                case 0:
                    setView('viewAccred');
                    vm.actualAdesione = 0;
                    break;
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    break;
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            //var spanEdit = 'span-select';
            //var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = vm.record != undefined && vm.record.Completed;
            vm.stepCompleted[1] = vm.record != undefined && vm.record.Completed;
            vm.stepCompleted[2] = vm.record != undefined && vm.record.attachChecked;
            vm.stepCompleted[3] = vm.record != undefined && vm.record.Sent;

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAccred':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                case 'viewAdes':
                    if (vm.record.Adesioni != undefined && vm.record.Adesioni[0] != undefined && vm.record.Adesioni[0].Id > 0)
                        able = true;
                    break;
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < vm.maxStep - 1 && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid || vm.saving;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.saving || vm.disableConfirm
                        || vm.record.SedeLegale_PEC != undefined && vm.record.SedeLegale_PEC.toLowerCase() != vm.confirm.SedeLegale_PEC.toLowerCase()
                        || vm.record.SedeLegale_Email != undefined && vm.record.SedeLegale_Email.toLowerCase() != vm.confirm.SedeLegale_Email.toLowerCase();
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }

        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }

        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }

        //Gestione per viewAccred
        function setShowPanelAccred1() {
            return vm.showPanelAccred1 = !vm.showPanelAccred1;
        }
        function setShowPanelAccred2() {
            return vm.showPanelAccred2 = !vm.showPanelAccred2;
        }

        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;
                        //console.info('getCNDProgetto', data);
                        var dt = new Date(vm.cndProgetto.DttmServer);
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");


                        vm.dtStartClickDay = new Date(vm.cndProgetto.DtStartClickDay);
                        vm.dtEndClickDay = new Date(vm.cndProgetto.DtEndClickDay);

                        vm.isClickDay = vm.cndProgetto.IsClickDay;

                        vm.endTime = vm.dtStartClickDay;
                        vm.countdown = (vm.dtStartClickDay - dt) / 1000;

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }


                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkVideoGuida(vm.cndProgetto.URL_YouTube);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');
                        sectionMenu.setProjectUID(vm.cndProgetto.UID);

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    }
                );
        }

        function save() {
            //console.info('save()', vm.record);
            unReset(vm.record);
            if (typeof vm.record.Id == 'undefined' || vm.record.Id == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta effettuando la registrazione, i dati inseriti non potranno essere modificati, procedere?', 'OK').then(
                    function () { //YES
                        vm.loading = true;
                        vm.saving = true;
                        return datacontext.cndRegister_save(vm.record).then(function (data) {
                            vm.loading = false;
                            vm.saving = false;
                            if (data == "400") {
                                return logError('Errore: campi non correttamente valorizzati. ');
                            }
                            else if (data == "404") {
                                return logError('Errore: non specifico. Dato non registrato. ');
                            }
                            else if (data == "403") {
                                return logError('Errore: il campo "CIR" gi\xE0 esistente. ');
                            }
                            else if (data == "409") {
                                return logError('Errore: il campo "Email" \xE8 gi\xE0 stato utilizzato da una utenza precedentemente. ');
                            }
                            else if (data == "406") {
                                return logError('Errore: partita IVA gi\xE0 esistente. ');
                            }
                            else if (data == "201") {
                                vm.disableConfirm = true;
                                return setView('viewConfirm');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        vm.saving = false;
                    }
                );
            }
        }

        function unReset(item) {
            if (item.L_PaeseNascId > 0) {
                item.L_ProvNascId = 0;
                item.L_ComuneNascId = 0;
            }

            if (item.L_Res_PaeseId > 0) {
                item.L_Res_ProvId = 0;
                item.L_Res_ComuneId = 0;
            }

            if (item.L_Dom_PaeseId > 0) {
                item.L_Dom_ProvId = 0;
                item.L_Dom_ComuneId = 0;
            }

            if (item.SedeLegale_PaeseId > 0) {
                item.SedeLegale_ProvId = 0;
                item.SedeLegale_ComuneId = 0;
            }

            if (item.SedeOperativa_PaeseId > 0) {
                item.SedeOperativa_ProvId = 0;
                item.SedeOperativa_ComuneId = 0;
            }
        }

        // *******************************************************
        // Metodi Comune - Provincia - Paese - Birth - Rappresentante Legale

        function getPaesiNascL() {
            if (vm.cmblist.l_nasc_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.l_nasc_paesi = data;
            });
        }
        function getProvinceNascL() {
            if (vm.cmblist.l_nasc_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.l_nasc_province = data;
            });
        }
        function reset_L_PaeseNasc() {
            if (vm.record.L_PaeseNascId != 0) {
                vm.record.L_ProvNascId = 0;
                reset_L_ComuneNasc(0);
            }
        }
        function reset_L_ComuneNasc(idprov) {
            vm.record.L_ComuneNascId = '';
            getComuni_NascL(idprov);
        }
        function getComuni_NascL(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.l_nasc_comuni = [];
            }

            if (vm.record.L_ProvinciaNascId != idprov)
                vm.cmblist.l_nasc_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.l_nasc_comuni = data;
            });
        }


        // *******************************************************
        // Metodi Comune - Provincia - Paese - Residenza - Rappresentante Legale

        function getPaesiResL() {
            if (vm.cmblist.l_res_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.l_res_paesi = data;
            });
        }
        function getProvinceResL() {
            if (vm.cmblist.l_res_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.l_res_province = data;
            });
        }
        function reset_L_PaeseRes() {
            if (vm.record.L_Res_PaeseId != 0) {
                vm.record.L_Res_ProvId = 0;
                //vm.record.L_Res_TIndirizzoId = 0;
                reset_L_ComuneRes(0);
            }
        }
        function reset_L_ComuneRes(idprov) {
            vm.record.L_Res_ComuneId = '';
            getComuni_ResL(idprov);
        }
        function getComuni_ResL(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.l_res_comuni = [];
            }

            if (vm.record.L_Res_ProvId != idprov)
                vm.cmblist.l_res_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.l_res_comuni = data;
            });
        }
        function getTIndirizzi_ResL() {
            if (vm.cmblist.l_res_tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.l_res_tIndirizzi = data;
            });
        }

        function reset_L_DomUgualeRes() {
            if (vm.record.L_DomUgualeRes) {
                vm.record.L_Dom_PaeseId = 0;
                vm.record.L_Dom_ProvId = 0;
                vm.record.L_Dom_ComuneId = 0;
                vm.record.L_Dom_TIndirizzoId = 0;
                vm.record.L_Dom_Indirizzo = '';
                vm.record.L_Dom_Civico = '';
                vm.record.L_Dom_Cap = '';
            }
        }

        // *******************************************************
        // Metodi Comune - Provincia - Paese - Domicilio - Rappresentante Legale

        function getPaesiDomL() {
            if (vm.cmblist.l_dom_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.l_dom_paesi = data;
            });
        }
        function getProvinceDomL() {
            if (vm.cmblist.l_dom_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.l_dom_province = data;
            });
        }
        function reset_L_PaeseDom() {
            if (vm.record.L_Dom_PaeseId != 0) {
                vm.record.L_Dom_ProvId = 0;
                //vm.record.L_Res_TIndirizzoId = 0;
                reset_L_ComuneRes(0);
            }
        }
        function reset_L_ComuneDom(idprov) {
            vm.record.L_Dom_ComuneId = '';
            getComuni_DomL(idprov);
        }
        function getComuni_DomL(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.l_dom_comuni = [];
            }

            if (vm.record.L_Dom_ProvId != idprov)
                vm.cmblist.l_dom_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.l_dom_comuni = data;
            });
        }
        function getTIndirizzi_DomL() {
            if (vm.cmblist.l_dom_tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.l_dom_tIndirizzi = data;
            });
        }


        // *******************************************************
        // Metodi Comune - Provincia - Paese - Sede Legale

        function getPaesiSedeLeg() {
            if (vm.cmblist.sedeLeg_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.sedeLeg_paesi = data;
            });
        }
        function getProvinceSedeLeg() {
            if (vm.cmblist.sedeLeg_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.sedeLeg_province = data;
            });
        }
        function reset_SedeLegale_Paese() {
            if (vm.record.SedeLegale_PaeseId != 0) {
                vm.record.SedeLegale_ProvId = 0;
                reset_SedeLegale_Comune(0);
            }
        }
        function reset_SedeLegale_Comune(idprov) {
            vm.record.SedeLegale_ComuneId = '';
            getComuni_SedeLeg(idprov);
        }
        function getComuni_SedeLeg(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.sedeLeg_comuni = [];
            }

            if (vm.record.SedeLegale_ProvId != idprov)
                vm.cmblist.sedeLeg_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.sedeLeg_comuni = data;
            });
        }
        function getTIndirizzi_SedeLeg() {
            if (vm.cmblist.sedeLeg_tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.sedeLeg_tIndirizzi = data;
            });
        }


        // *******************************************************
        // Metodi Comune - Provincia - Paese - Sede Operativa

        function getPaesiSedeOp() {
            if (vm.cmblist.sedeOp_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.sedeOp_paesi = data;
            });
        }
        function getProvinceSedeOp() {
            if (vm.cmblist.sedeOp_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.sedeOp_province = data;
            });
        }
        function reset_SedeOperativa_Paese() {
            if (vm.record.SedeOperativa_PaeseId != 0) {
                vm.record.SedeOperativa_ProvId = 0;
                reset_SedeOperativa_Comune(0);
            }
        }
        function reset_SedeOperativa_Comune(idprov) {
            vm.record.SedeOperativa_ComuneId = '';
            getComuni_SedeOp(idprov);
        }
        function getComuni_SedeOp(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.sedeOp_comuni = [];
            }

            if (vm.record.SedeOperativa_ProvId != idprov)
                vm.cmblist.sedeOp_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.sedeOp_comuni = data;
            });
        }
        function getTIndirizzi_SedeOp() {
            if (vm.cmblist.sedeOp_tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.sedeOp_tIndirizzi = data;
            });
        }

        // *************************
        // Studio Notarile Consorzio

        function getProvinceStudioNot() {
            if (vm.cmblist.studioNot_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.studioNot_province = data;
            });
        }
        function reset_StudioNot_Comune(idprov) {
            vm.record.Associazione_StudioNotarile_ComuneId = '';
            getComuni_StudioNot(idprov);
        }
        function getComuni_StudioNot(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.studioNot_comuni = [];
            }

            if (vm.record.Associazione_StudioNotarile_ProvId != idprov)
                vm.cmblist.studioNot_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.studioNot_comuni = data;
            });
        }


        // *************************
        // Registro Consorzio

        function getProvinceConsReg() {
            if (vm.cmblist.consReg_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.consReg_province = data;
            });
        }
        function reset_ConsReg_Comune(idprov) {
            vm.record.Associazione_Reg_ComuneId = '';
            getComuni_ConsReg(idprov);
        }
        function getComuni_ConsReg(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.consReg_comuni = [];
            }

            if (vm.record.Associazione_Reg_ProvId != idprov)
                vm.cmblist.consReg_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.consReg_comuni = data;
            });
        }


        // ************************
        // Reset campi consorzio

        function reset_consorzio() {
            if (vm.record.TAssociazioneId != 3) {
                vm.record.Associazione_Atto_Num = '';
                vm.record.Associazione_Atto_Dt = '';
                vm.record.Associazione_StudioNotarile_Titolo = '';
                vm.record.Associazione_StudioNotarile_ComuneId = 0;
                vm.record.Associazione_Reg_ComuneId = 0;
                vm.record.Associazione_Reg_Num = '';
                vm.record.Associazione_Reg_Dt = '';
            }
        }


        // *************************
        // Elenchi
        function getTAssociazione() {
            //if (vm.cmblist.tAssociazioni.length > 0) return;

            //datacontext.arrTAssociazioni().then(function (data) {
            //    vm.cmblist.tAssociazioni = data;
            //});
        }
        function getTOrganismo() {
            //if (vm.cmblist.tOrganismi.length > 0) return;

            //datacontext.arrTOrganismi().then(function (data) {
            //    vm.cmblist.tOrganismi = data;
            //});
        }


        // ******************************
        // showAlert
        function showAlertDivs(errorAccess) {
            var msg = '';

            vm.errorAccess = errorAccess;

            if (errorAccess == 'linkError') {
                msg = 'Attenzione! Il link utilizzato e\' errato.';
            }

            if (msg != '') return logError(msg);

            return false;
        }
        //*****************************************************
        //Elenchi Parametri

        function getTAteco() {
            if (vm.cmblist.tAteco.length > 0) return;

            datacontext.arrTipoAteco().then(function (data) {
                vm.cmblist.tAteco = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-SUGGESTION PER CODICE ATECO-#-#-#-#-#-#

        //Define Suggestions List
        vm.validAteco = false;
        vm.suggestionsAteco = [];
        vm.suggestionsObjAteco = [];
        //Define Selected Suggestion Item
        vm.selectedIndexAteco = -1;

        //Function To Call On ng-change
        vm.searchAteco = function () {
            //console.log('searchAteco()');
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
            if (vm.record.searchTextAteco == undefined) return;
            if (vm.record.searchTextAteco.length < 2) return; //numero minimo di caratteri

            return datacontext.tAteco_getByText(vm.record.searchTextAteco).then(function (data) {
                //console.log(data);
                if (data) {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = data;
                    data.forEach(function (item) {
                        vm.suggestionsAteco.push(item.Name);
                    });
                }
                if (vm.suggestionsAteco.length == 1) {
                    vm.AssignValueAndHideAteco(0);
                }
            });
        };

        vm.resetTextAteco = function () {
            if (vm.record.TAtecoId > 0) {
                vm.record.TAtecoId = '';
                vm.validAteco = false;
                vm.record.searchTextAteco = '';
            }
        };

        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndexAteco', function (val) {
            if (val !== -1 && typeof val != 'undefined') {
                vm.record.searchTextAteco = vm.suggestionsAteco[vm.selectedIndexAteco];
                vm.record.TAtecoId = vm.suggestionsObjAteco[vm.selectedIndexAteco].Id;
                vm.validAteco = true;
            }
        });


        //Text Field Events
        //Function To Call on ng-keydown
        vm.checkKeyDownAteco = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco + 1 !== vm.suggestionsAteco.length) {
                    vm.selectedIndexAteco++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco - 1 !== -1) {
                    vm.selectedIndexAteco--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                vm.suggestionsAteco = [];
                vm.suggestionsObjAteco = [];
            }
        };
        //Function To Call on ng-keyup
        vm.checkKeyUpAteco = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if (vm.record.searchTextAteco == "") {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = [];
                }
            } else {
                if (vm.record.TAtecoId > 0) {
                    vm.record.TAtecoId = '';
                    vm.validAteco = false;
                    vm.record.searchTextAteco = '';
                }
            }
        };
        //======================================

        //List Item Events
        //Function To Call on ng-click
        vm.AssignValueAndHideAteco = function (index) {
            //console.log('hide');
            vm.record.searchTextAteco = vm.suggestionsAteco[index];
            vm.record.TAtecoId = vm.suggestionsObjAteco[index].Id;
            //vm.record.AtecoId = vm.record.TAtecoId;
            vm.validAteco = true;
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
        };
        //======================================


        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.getValidPIVA = function (value) {
            vm.validPIVA = false;
            if (value == undefined || value == "") return vm.validPIVA = true;
            if (value.length != 11) return; //numero minimo di caratteri            
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = function (value) {
            vm.validCF = false;
            if (value == undefined || value == "") return vm.validCF = true;
            if (value.length != 16) return; //numero minimo di caratteri            
            return datacontext.validazione_cf(value).then(function (data) {
                return vm.validCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.getValidFieldsCF = function () {
            vm.validFieldsCF = vm.record.L_CodiceFiscale != undefined && vm.record.L_CodiceFiscale.length > 10 ? false : true;
            if (vm.record.L_CodiceFiscale == undefined) return;
            if (vm.record.L_CodiceFiscale.length != 16) return; //numero minimo di caratteri
            if (vm.record.L_Nome == undefined) return;
            if (vm.record.L_Cognome == undefined) return;
            if (vm.record.L_Sesso == undefined) return;
            if (vm.record.L_PaeseNascId == 0 && (vm.record.L_ComuneNascId == undefined || vm.record.L_ComuneNascId == 0)) return;
            if (vm.record.L_DtNasc == undefined || vm.record.L_DtNasc == '') return;
            var strDtNasc = common.dateToString(vm.record.L_DtNasc); //la data deve avere formato dd/MM/yyyy            
            return datacontext.validazione_fieldsCF(vm.record.L_CodiceFiscale, vm.record.L_Nome, vm.record.L_Cognome, vm.record.L_Sesso, strDtNasc, vm.record.L_PaeseNascId, vm.record.L_ComuneNascId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        };



    }
})();
